import { safeLocalStorage, safeSessionStorage } from './safeStorage';
const PREFIX = 'mekandapro:';
export const readWorkspace = (key, fallback = null) => {
  try { return JSON.parse(safeSessionStorage.getItem(PREFIX + key)) ?? fallback; } catch { return fallback; }
};
export const writeWorkspace = (key, value) => { try { safeSessionStorage.setItem(PREFIX + key, JSON.stringify(value)); } catch { /* Storage may be full or disabled. */ } };
export const clearWorkspace = () => {
  [safeSessionStorage, safeLocalStorage].forEach(storage => {
    try { storage.keys().filter(k => k.startsWith(PREFIX)).forEach(k => storage.removeItem(k)); } catch { /* optional cache */ }
  });
};
export const bindWorkspaceOwner = (id) => {
  if (!id) return;
  if (safeSessionStorage.getItem('mp_workspace_owner') !== id || safeLocalStorage.getItem('mp_workspace_owner') !== id) clearWorkspace();
  safeSessionStorage.setItem('mp_workspace_owner', id);
  safeLocalStorage.setItem('mp_workspace_owner', id);
};
export const searchSignature = (text, filters) => JSON.stringify([text.trim(), filters]);
export const safeReturnPath = (path) => typeof path === 'string' && /^\/(organizer|venue|venues|admin|dashboard|pro|swipe)(\/|\?|$)/.test(path) ? path : null;
export const rememberReturnPath = () => { try { safeSessionStorage.setItem('mp_return_to', window.location.pathname + window.location.search); } catch {} };
export const consumeReturnPath = () => { const path = safeSessionStorage.getItem('mp_return_to'); safeSessionStorage.removeItem('mp_return_to'); return safeReturnPath(path); };
